import { render, staticRenderFns } from "./WorksDetail.vue?vue&type=template&id=0ba24a9e&scoped=true"
import script from "./WorksDetail.vue?vue&type=script&lang=js"
export * from "./WorksDetail.vue?vue&type=script&lang=js"
import style0 from "./WorksDetail.vue?vue&type=style&index=0&id=0ba24a9e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ba24a9e",
  null
  
)

export default component.exports